import { createGlobalStyle } from 'styled-components';
import { COLORS, CONTAINER_MAX_WIDTH, MediaQueryMobileOnly } from './utils/constants';

const GlobalCSS = createGlobalStyle`
.simple-btn:is([disabled]) {
  opacity: 0.5;
}

.simple-btn:not([disabled]) {
  opacity: 1;
  outline: 0;
  transition: all 0.2s;
  
  &:not(.disabled) {
    cursor: pointer;
  }
  &:hover:not(.disabled):not(:disabled):not(.pancake-button--disabled):not(.pancake-button--disabled):not(:active) {
    opacity: 0.8;
  }

  &:active:not(.disabled):not(:disabled):not(.pancake-button--disabled):not(.pancake-button--disabled) {
    opacity: 0.85;
  }
  &a:hover {
    color: unset;
  }
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.full-width {
  width: 80vw;
  max-width: 1000px;
}

p {
  display: block;
  line-height: 28px;
  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:landscape) {
    font-size:calc((1.2 - 1) * 1.2vw + 1rem)
  }

  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:portrait) {
    font-size:calc((1.2 - 1) * 1.2vh + 1rem)
  }

  @media screen and (min-width: 1944px) {
    font-size:calc(1.2 * 1rem)
  }
}




h1 {
  max-width: ${CONTAINER_MAX_WIDTH}px;
  font-weight: bold;
  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:landscape) {
    font-size:calc((4 - 1) * 1.2vw + 1rem)
  }

  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:portrait) {
    font-size:calc((4 - 1) * 1.2vh + 1rem)
  }

  @media screen and (min-width: 1944px) {
    font-size:calc(4 * 1rem)
  }
}
h2 {
  font-weight: bold;
  max-width: ${CONTAINER_MAX_WIDTH}px;
  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:landscape) {
    font-size:calc((2.8 - 1) * 1.2vw + 1rem)
  }

  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:portrait) {
    font-size:calc((2.8 - 1) * 1.2vh + 1rem)
  }

  @media screen and (min-width: 1944px) {
    font-size:calc(2.8 * 1rem)
  }
}

h3 { 
  max-width: ${CONTAINER_MAX_WIDTH}px;
  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:landscape) {
    font-size:calc((2.2 - 1) * 1.2vw + 1rem)
  }

  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:portrait) {
    font-size:calc((2.2 - 1) * 1.2vh + 1rem)
  }

  @media screen and (min-width: 1944px) {
    font-size:calc(2.2 * 1rem)
  }
}

h4 { 
  max-width: ${CONTAINER_MAX_WIDTH}px;
  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:landscape) {
    font-size:calc((1.6 - 1) * 1.2vw + 1rem)
  }

  @media screen and (min-width: 0) and (max-width:calc(1944px - 1px)) and (orientation:portrait) {
    font-size:calc((1.6 - 1) * 1.2vh + 1rem)
  }

  @media screen and (min-width: 1944px) {
    font-size:calc(1.6 * 1rem)
  }
}

.highlight {
  color: ${COLORS.highlight}
}

.secondary {
  color: ${COLORS.secondary}
}

.text-title {
  color: white;
  font-size: 56px;
  ${MediaQueryMobileOnly} {
    font-size: 40px;
  }
}



`;

export default GlobalCSS;
